module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/home')
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.pageTitle) + " \n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "max-width": "800px"
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.dashes), function(dash) {
    return _c('v-list-item', {
      key: dash.name,
      on: {
        "click": function($event) {
          return _vm.selectDash(dash)
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-icon', [_vm._v("insert_chart")])], 1), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(dash.name))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(dash.section) + " - " + _vm._s(dash.field))])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("info")])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex-grow": "1"
    }
  }, [(!_vm.editMode) ? _c('div', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right",
      "z-index": "1000"
    },
    attrs: {
      "color": "grey lighten-2",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.editMode = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('Dashboard', {
    attrs: {
      "dash": _vm.dash
    }
  })], 1) : _c('div', {
    attrs: {
      "transition": "slide-x-transition"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.dash.name),
      callback: function($$v) {
        _vm.$set(_vm.dash, "name", $$v)
      },
      expression: "dash.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Section"
    },
    model: {
      value: (_vm.dash.section),
      callback: function($$v) {
        _vm.$set(_vm.dash, "section", $$v)
      },
      expression: "dash.section"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Field"
    },
    model: {
      value: (_vm.dash.field),
      callback: function($$v) {
        _vm.$set(_vm.dash, "field", $$v)
      },
      expression: "dash.field"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveDash(_vm.dash)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.editMode = false
      }
    }
  }, [_vm._v("Cancel")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5b18230"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboards.vue
// module id = 2669
// module chunks = 1